import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessor } from '@ngneat/reactive-forms';

@Component({
  selector: 'bs-value-hover',
  templateUrl: './value-hover.component.html',
  styleUrls: ['./value-hover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ValueHoverComponent,
      multi: true,
    },
  ],
})
export class ValueHoverComponent implements ControlValueAccessor {
  writeValue(value: any): void {}
  onChange?: ((value: any) => void) | undefined;
  onTouched?: (() => void) | undefined;
  registerOnChange(fn: (value: any) => void): void {}
  registerOnTouched(fn: () => void): void {}
  @Input() firstValue!: string | number;
  @Input() secondValue!: string | number;
}
